import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    user: [],
    userProfile: [],
    isLoggedIn: false,
    permissions: {} ,  // ✅ single permission store
    isPasswordChangedSuccess: false,
    isAccountActivationSuccess: false,
    isChangePasswordActiveAccount: false,
    accountActivationMessage: null,
    isUserUpdateSuccess: false,
    isUserUpdateError: false,
    isForgetPasswordSuccess: false,
    isSetForgetPasswordSuccess: false,
    selectedForgetEmail: null,
    isLogoutResponse: false,
    //
    leadModulePermission: {}, // individual module permission state (for Lead)
    leadArchieveModulePermission: {}, // example: for Lead Archive module
    leadEstimateModulePermission: {}, // example: for Lead Estimate module
    leadJobModulePermission: {}, // example: for Lead Job module
    leadCompletionModulePermission: {}, // example: for Lead Completion module
    leadConfirmationModulePermission: {}, // example: for Lead Confirmation module
    leadLogModulePermission: {}, // example: for Lead Log module
    leadProvisionalModulePermission: {}, // example: for Lead Provisional module
    leadQuotationModulePermission: {}, // example: for Lead Quotation module
    leadSurveyModulePermission: {}, // example: for Lead Survey module
    notificationModulePermission: {}, // example: for Notification module
    paymentModulePermission: {}, // example: for Payment module
    settingCompanyModulePermission: {}, // example: for Company module
    settingDocumentModulePermission: {}, // example: for Document module
    settingFeedbackModulePermission: {}, // example: for Feedback module
    settingOwnerModulePermission: {}, // example: for Owner module
    settingRoleModulePermission: {}, // example: for Role module
    settingStaffModulePermission: {}, // example: for Staff module
    settingWorkerModulePermission: {}, // example: for Worker module
    surveyTaskModulePermission: {}, // example: for Survey Task module
    workDiaryModulePermission: {}, // example: for Work Diary module
    invoiceModulePermission: {}, // example: for Invoice module
    communicationEmailModulePermission: {}, // example: for Email module
    communicationSmsModulePermission: {}, // example: for SMS module
    fileUploadModulePermission: {}, // example: for File Upload module
    // Professional plan
    operationModulePermission: {}, // individual module permission state (for Operation)
    operationVehicleTypeModulePermission: {}, // example: for Vehicle Type module
    operationSkillModulePermission: {}, // example: for Skill module
    operationQuickBookModulePermission: {}, // example: for QuickBook module
    operationVehicleModulePermission: {}, // example: for Vehicle module
    operationStaffModulePermission: {}, // example: for Staff module
    operationWorkerAssignModulePermission: {}, // example: for Worker module
    customerLoginResponse: {},
    customerLinkErrorResponse: null,
    isResentLinkCustomerPortal: false,
    isCustomerTokenInValid: false,
    isSendOtpSuccess: false,
    isVerifyOtpSuccess: false,
    loginFailedResponse: null,
  },
  reducers: {
    getUserAction: (state, { payload }) => {},
    setUserAction: (state, { payload }) => {
      console.log("payload", payload);
      state.user = payload;
    },
    setLoginFailedResponse: (state, { payload }) => {
      state.loginFailedResponse = payload;
    },
    getUserProfile: (state) => {},
    setUserProfile: (state, { payload }) => {
      console.log("payload", payload);
      state.userProfile = payload;
    },
    setPermissionsAction: (state, { payload }) => {
      state.permissions = payload;
    },

    // Set individual module permissions
    setLeadModulePermissionAction: (state, { payload }) => {
      state.leadModulePermission = payload;
    },

    setLeadArchieveModulePermissionAction: (state, { payload }) => {
      state.leadArchieveModulePermission = payload;
    },
    setLeadEstimateModulePermissionAction: (state, { payload }) => {
      state.leadEstimateModulePermission = payload;
    },
    setLeadJobModulePermissionAction: (state, { payload }) => {
      state.leadJobModulePermission = payload;
    },
    setLeadCompletionModulePermissionAction: (state, { payload }) => {
      state.leadCompletionModulePermission = payload;
    },
    setLeadConfirmationModulePermissionAction: (state, { payload }) => {
      state.leadConfirmationModulePermission = payload;
    },
    setLeadLogModulePermissionAction: (state, { payload }) => {
      state.leadLogModulePermission = payload;
    },
    setLeadProvisionalModulePermissionAction: (state, { payload }) => {
      state.leadProvisionalModulePermission = payload;
    },
    setLeadQuotationModulePermissionAction: (state, { payload }) => {
      state.leadQuotationModulePermission = payload;
    },
    setLeadSurveyModulePermissionAction: (state, { payload }) => {
      state.leadSurveyModulePermission = payload;
    },
    setNotificationModulePermissionAction: (state, { payload }) => {
      state.notificationModulePermission = payload;
    },
    setPaymentModulePermissionAction: (state, { payload }) => {
      state.paymentModulePermission = payload;
    },
    setSettingCompanyModulePermissionAction: (state, { payload }) => {
      state.settingCompanyModulePermission = payload;
    },
    setSettingDocumentModulePermissionAction: (state, { payload }) => {
      state.settingDocumentModulePermission = payload;
    },
    setSettingFeedbackModulePermissionAction: (state, { payload }) => {
      state.settingFeedbackModulePermission = payload;
    },
    setSettingOwnerModulePermissionAction: (state, { payload }) => {
      state.settingOwnerModulePermission = payload;
    },
    setSettingRoleModulePermissionAction: (state, { payload }) => {
      state.settingRoleModulePermission = payload;
    },
    setSettingStaffModulePermissionAction: (state, { payload }) => {
      state.settingStaffModulePermission = payload;
    },
    setSettingWorkerModulePermissionAction: (state, { payload }) => {
      state.settingWorkerModulePermission = payload;
    },
    setSurveyTaskModulePermissionAction: (state, { payload }) => {
      state.surveyTaskModulePermission = payload;
    },
    setWorkDiaryModulePermissionAction: (state, { payload }) => {
      state.workDiaryModulePermission = payload;
    },
    setInvoiceModulePermissionAction: (state, { payload }) => {
      state.invoiceModulePermission = payload;
    },
    setCommunicationEmailModulePermissionAction: (state, { payload }) => {
      state.communicationEmailModulePermission = payload;
    },
    setCommunicationSmsModulePermissionAction: (state, { payload }) => {
      state.communicationSmsModulePermission = payload;
    },
    setFileUploadModulePermissionAction: (state, { payload }) => {
      state.fileUploadModulePermission = payload;
    },

    // end module permission
    updateUserProfileAction: (state, { payload }) => {},
    setUpdateProfileSuccess: (state, { payload }) => {
      state.isUserUpdateSuccess = payload;
    },

    setUpdateProfileError: (state, { payload }) => {
      state.isUserUpdateError = payload;
    },

    getChangePasswordAction: (state, { payload }) => {},
    setChangePasswordAction: (state, { payload }) => {
      state.isPasswordChangedSuccess = payload;
    },

    getForgetPasswordAction: (state, { payload }) => {},
    setForgetPasswordAction: (state, { payload }) => {
      state.isForgetPasswordSuccess = payload;
    },
    setSelectedForgetEmailAction: (state, { payload }) => {
      state.selectedForgetEmail = payload?.payload?.email;
    },

    addAccountActivationAction: (state, { payload }) => {},
    setAccountActivationAction: (state, { payload }) => {
      state.isAccountActivationSuccess = payload;
    },

    changePasswordActiveAccount: (state, { payload }) => {},
    setChangePasswordActiveAccountResponse: (state, { payload }) => {
      state.isChangePasswordActiveAccount = payload;
    },

    setAccountActivationMessage: (state, { payload }) => {
      state.accountActivationMessage = payload;
    },

    forgetResetPasswordAction: (state, { payload }) => {},
    setForgetResetPasswordAction: (state, { payload }) => {
      state.isSetForgetPasswordSuccess = payload;
    },

    setLogoutAction: (state, { payload }) => {
      state.user = [];
      state.permissions = {};
      state.userProfile = [];
    },

    setLogoutResponseAction: (state, { payload }) => {
      state.isLogoutResponse = payload;
    },
    setIsLoggedIn: (state, { payload }) => {
      state.isLoggedIn = payload;
    },

    getCustomerLoginResponse: (state, { payload }) => {},
    setCustomerLoginResponse: (state, { payload }) => {
      state.customerLoginResponse = payload;
    },

    setCustomerLinkErrorResponse:(state, { payload }) => {
      state.customerLinkErrorResponse = payload;
    },

    setCustomerTokenInValidAction: (state, { payload }) => {
      state.isCustomerTokenInValid = payload;
    },

    resentLinkCustomerPortalAction: (state, { payload }) => {},
    setResentLinkCustomerPortalAction: (state, { payload }) => {
      state.isResentLinkCustomerPortal = payload;
    },

    sendOtpAction: (state, { payload }) => {},
    setSendOtpAction: (state, { payload }) => {
      state.isSendOtpSuccess = payload;
    },

    verifyOtpAction: (state, { payload }) => {},
    setVerifyOtpAction: (state, { payload }) => {
      state.isVerifyOtpSuccess = payload;
    },
  },
});

const {
  getUserAction,
  setLoginFailedResponse,
  setUserAction,
  getUserProfile,
  setUserProfile,
  setPermissionsAction,
  updateUserProfileAction,
  setUpdateProfileSuccess,
  setUpdateProfileError,
  getChangePasswordAction,
  setChangePasswordAction,
  getForgetPasswordAction,
  setForgetPasswordAction,
  addAccountActivationAction,
  changePasswordActiveAccount,
  setChangePasswordActiveAccountResponse,
  setAccountActivationAction,
  forgetResetPasswordAction,
  setForgetResetPasswordAction,
  setSelectedForgetEmailAction,
  setLogoutAction,
  setIsLoggedIn,
  setLogoutResponseAction,
  setLeadModulePermissionAction,
  setAccountActivationMessage,
  // Individual module permissions
  setSettingCompanyModulePermissionAction,
  setLeadArchieveModulePermissionAction,
  setLeadEstimateModulePermissionAction,
  setLeadJobModulePermissionAction,
  setLeadCompletionModulePermissionAction,
  setLeadConfirmationModulePermissionAction,
  setLeadLogModulePermissionAction,
  setLeadProvisionalModulePermissionAction,
  setLeadQuotationModulePermissionAction,
  setLeadSurveyModulePermissionAction,
  setNotificationModulePermissionAction,
  setPaymentModulePermissionAction,
  setSettingDocumentModulePermissionAction,
  setSettingFeedbackModulePermissionAction,
  setSettingOwnerModulePermissionAction,
  setSettingRoleModulePermissionAction,
  setSettingStaffModulePermissionAction,
  setSettingWorkerModulePermissionAction,
  setSurveyTaskModulePermissionAction,
  setWorkDiaryModulePermissionAction,
  setInvoiceModulePermissionAction,
  setCommunicationEmailModulePermissionAction,
  setCommunicationSmsModulePermissionAction,
  setFileUploadModulePermissionAction,
  getCustomerLoginResponse,
  setCustomerLoginResponse,
  setCustomerLinkErrorResponse,
  resentLinkCustomerPortalAction,
  setResentLinkCustomerPortalAction,
  sendOtpAction,
  setSendOtpAction,
  verifyOtpAction,
  setVerifyOtpAction,
  setCustomerTokenInValidAction
} = userSlice.actions;

export {
  getUserAction,
  setLoginFailedResponse,
  setUserAction,
  getUserProfile,
  setUserProfile,
  setPermissionsAction,
  updateUserProfileAction,
  setUpdateProfileSuccess,
  setUpdateProfileError,
  getChangePasswordAction,
  setChangePasswordAction,
  getForgetPasswordAction,
  setForgetPasswordAction,
  addAccountActivationAction,
  changePasswordActiveAccount,
  setChangePasswordActiveAccountResponse,
  setAccountActivationAction,
  forgetResetPasswordAction,
  setForgetResetPasswordAction,
  setAccountActivationMessage,
  setSelectedForgetEmailAction,
  setLogoutAction,
  setIsLoggedIn,
  setLogoutResponseAction,
  setLeadModulePermissionAction,
  setSettingCompanyModulePermissionAction,
  setLeadArchieveModulePermissionAction,
  setLeadEstimateModulePermissionAction,
  setLeadJobModulePermissionAction,
  setLeadCompletionModulePermissionAction,
  setLeadConfirmationModulePermissionAction,
  setLeadLogModulePermissionAction,
  setLeadProvisionalModulePermissionAction,
  setLeadQuotationModulePermissionAction,
  setLeadSurveyModulePermissionAction,
  setNotificationModulePermissionAction,
  setPaymentModulePermissionAction,
  setSettingDocumentModulePermissionAction,
  setSettingFeedbackModulePermissionAction,
  setSettingOwnerModulePermissionAction,
  setSettingRoleModulePermissionAction,
  setSettingStaffModulePermissionAction,
  setSettingWorkerModulePermissionAction,
  setSurveyTaskModulePermissionAction,
  setWorkDiaryModulePermissionAction,
  setInvoiceModulePermissionAction,
  setCommunicationEmailModulePermissionAction,
  setCommunicationSmsModulePermissionAction,
  setFileUploadModulePermissionAction,
  getCustomerLoginResponse,
  setCustomerLoginResponse,
  setCustomerLinkErrorResponse,
  resentLinkCustomerPortalAction,
  setResentLinkCustomerPortalAction,
  sendOtpAction,
  setSendOtpAction,
  verifyOtpAction,
  setVerifyOtpAction,
  setCustomerTokenInValidAction
};

export default userSlice.reducer;
